/**
 * Created by Victor Rojo on 15/10/18.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';
import {IPlaceValuelistService} from "./iPlace-valuelist.service";

@Pipe({name: 'IPlace'})
export class IPlacePipe implements PipeTransform {

  constructor(private valuelist: IPlaceValuelistService) {
  }

  transform(value: string, field: string): string {
    let list = this.valuelist.getValuelist();
    return list[value] && list[value][field] || "";
  }
}
